export const usa_flag = "../../../images/global/usa_flag.png";
